// extracted by mini-css-extract-plugin
module.exports = {"rating-stars-field":"RatingStarsField_rating-stars-field__2nZGd","rating-stars":"RatingStarsField_rating-stars__2zaIi"};